module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "BankCamera");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BankCamera!./src/pages/Shop/BankCamera/index.js
// module id = 901
// module chunks = 431